export default __webpack_public_path__ + "static/media/Refund-Policy.e11e81e2.jpg";